<template>
  <v-snackbar v-model="innerShow" :timeout="timeout" min-width="0" class="mb-10">
    {{ message }}
  </v-snackbar>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
export default {
  data() {
    return {
      innerShow: this.show,
    }
  },
  watch: {
    innerShow(v) {
      if (v === false) {
        this.close()
      }
    },
    show(v) {
      this.innerShow = v
    },
  },
  computed: {
    ...mapState('ui/toast', ['show', 'message', 'timeout']),
  },
  methods: {
    ...mapMutations('ui/toast', ['close']),
  },
}
</script>

<style lang="scss" scoped>
::v-deep .v-snack {
  &__content {
    padding: 14px 24px;
    line-height: 1.5;
    font-size: 15px;
  }

  &__wrapper {
    border-radius: 8px;
    background-color: $gray-80;
    margin: 8px 16px;
  }
}
</style>
